import React from "react";
import Logo from "../../assets/others/logo.png";


const AnalysingIndicator = () => {
  return (
    <div className="relative">
      <div className="flex z-0 items-center justify-center rounded-full aspect-square w-32 delay-500 h-auto bg-gray-800 ring-inset ring-4 border-2 border-gray-700 ring-gray-900 animate-ping">
        <span className="rounded-full aspect-square w-8 bg-gray-400 animate-ping" />
      </div>
      <div className="absolute z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 aspect-square overflow-visible">
        <img
          src={Logo}
          alt="Logo"
          className="w-full h-full object-contain animate-zoom"
        />
      </div>
    </div>
  );
};


const AnalysingToast = ({ text }) => {
  return (
    <div className="toast p-1.5 px-6 flex items-center shadow-md justify-center bg-gradient-to-r from-transparent via-gray-800/75 to-transparent animate-bounce">
      <p className="text-gray-300 text-sm whitespace-nowrap tracking-wider italic animate-pulse">
        {text}
      </p>
    </div>
  );
};

export { AnalysingIndicator, AnalysingToast };
